import { render, staticRenderFns } from "./LungLesionScoreAnalysisComponent.vue?vue&type=template&id=48546d77&"
import script from "./LungLesionScoreAnalysisComponent.vue?vue&type=script&lang=ts&"
export * from "./LungLesionScoreAnalysisComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports